<template>
  <div class="icon-background" :style="{background: background}">
    <i :class="`fa-regular ${icon}`" :style="{color: iconColor}"></i>
  </div>
</template>


<style lang="scss">
.icon-background{
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;


svg {
  color: white;
  font-size: 27px
}
}
</style>

<script>
export default {
  props:['icon', 'background', 'iconColor'],
}
</script>